import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";

import MDButton from "components/MDButton";

// Reusable confirmation dialog — replaces ad-hoc window.confirm() calls.
function ConfirmDialog({
  open,
  title,
  message,
  confirmText,
  confirmColor,
  loading,
  onConfirm,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={onClose} color="secondary" variant="text" disabled={loading}>
          Cancel
        </MDButton>
        <MDButton onClick={onConfirm} color={confirmColor} variant="contained" disabled={loading}>
          {loading ? "Working..." : confirmText}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.node.isRequired,
  confirmText: PropTypes.string,
  confirmColor: PropTypes.string,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

ConfirmDialog.defaultProps = {
  title: "Confirm",
  confirmText: "Confirm",
  confirmColor: "error",
  loading: false,
};

export default ConfirmDialog;
